const slides = document.querySelectorAll('.partner_logo');
class PartnersSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            autoPlay: true,
			pageDots: false,
            prevNextButtons: true,
            wrapAround: true,
            groupCells: true,
            cellSelector: ".partner_logo",

        };

        if(this.$el.length) {
            this._createSlider();
        }
    }

    _createSlider() {
        if(slides.length > 6) {
            $('.partner-logo_section').removeClass("no-slider");
            this.$el.flickity(this.options);
        } 
    }           
}

export default PartnersSlider;
